import { NgModule } from '@angular/core';
import { BaseDataComponent } from './components/base-data/base-data.component';
import {SharedModule} from '../shared/shared.module';
import { ContactDetailComponent } from './components/contact-detail/contact-detail.component';
import {RouterModule} from '@angular/router';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CompanyDetailComponent} from './components/company-detail/company-detail.component';
import {SalesunitDetailComponent} from './components/salesunit-detail/salesunit-detail.component';
import { OrderModule } from 'ngx-order-pipe';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    NgxDatatableModule,
    OrderModule,
    MyDatePickerModule,
  ],
  declarations: [
    SalesunitDetailComponent,
    CompanyDetailComponent,
    ContactDetailComponent,
    BaseDataComponent
  ]
})
export class BaseDataModule { }



// WEBPACK FOOTER //
// ./src/app/base-data/base-data.module.ts